import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { userInfoStore } from '../../../store/userInfoStore';
import { isMobile } from '../../../core/helpers/isMobile';
import RePlayInfoIcon from '../../../components/common/rePlayInfoIcon';
import { getGameImages } from '../../../core/helpers/getGameImages';

const RePlayInfoIconWrapper = observer(() => {
  const { isReplay } = userInfoStore;

  const { rePlayInfoIcon } = useMemo(() => {
    return getGameImages();
  }, []);

  const { containerConfig } = useMemo(() => {
    return {
      containerConfig: {
        x: isMobile() ? 40 : 90,
        y: isMobile() ? 90 : 110,
      },
    };
  }, []);

  if (!isReplay) {
    return null;
  }

  return <RePlayInfoIcon containerConfig={containerConfig} rePlayInfoIcon={rePlayInfoIcon} />;
});
export default RePlayInfoIconWrapper;
